import { coreActions } from '@sonar-software/sonar-core';
import { createAsyncSelectors } from '@lib/selectors';
import { FilterComponent } from '@ui/table-modifier/filters';
import { getDirectParent } from '@lib/popups';
import { getFilterId } from '@ui/table-modifier/@arch/lib';
import { OptionFilter } from '@periscopes/general/filters';

import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useMemo } from 'react';
import { useAction, useAsyncState, useOnMount } from '@hooks';

const noPrefix = '""';
const prefixSelectors = createAsyncSelectors((state) => state.core.dataSecurity.setupAuditTrail.sourceNamePrefix.get);

export const SourceNamePrefixFilter: FilterComponent<Array<string>> = (props) => {
	const { format, id, label, onChange, value } = props;

	const { data } = useAsyncState(prefixSelectors);
	const getSetupAuditTrailSourceNamePrefix = useAction(coreActions.requestGetCoreSetupAuditTrailSourceNamePrefix);
	const valueWithEmpty = value?.map((prefix) => (Number(prefix) === 0 ? noPrefix : prefix));

	useOnMount(() => {
		getSetupAuditTrailSourceNamePrefix();
	});

	const options = useMemo(() => data?.sourceNamespacePrefixes.map((prefix) => ({
		label: prefix ? prefix : COPY_SPECIFIC.NO_PREFIX,
		value: prefix ? prefix : noPrefix
	})) ?? [], [ data ]);

	return (
		<FilterComponent
			{ ...props }
			tagProps={ {
				value: options
					?.filter((option) => valueWithEmpty?.includes(option.value))
					.map((option) => option.label)
					.join(', ')
			} }>
			<OptionFilter
				className='filter'
				getPopupContainer={ getDirectParent }
				id={ getFilterId(id) }
				maxTagCount='responsive'
				mode='multiple'
				onChange={ (prefixes: Array<string>) => {
					onChange({
						[ id ]: {
							format,
							value: prefixes
						}
					});
				} }
				options={ options }
				placeholder={ PLACEHOLDERS_COPY.FILTER_BY(label) }
				showArrow
				value={ valueWithEmpty } />
		</FilterComponent>
	);
};
